import { render, staticRenderFns } from "./restrictions.vue?vue&type=template&id=c27d414e&"
import script from "./restrictions.vue?vue&type=script&lang=js&"
export * from "./restrictions.vue?vue&type=script&lang=js&"
import style0 from "./restrictions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "restrictions.vue"
export default component.exports